import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import apiClient from "@/lib/apiClient";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { loginWithToken } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash;
    const sessionId = new URLSearchParams(hash.replace("#", "")).get("session_id");
    if (!sessionId) {
      navigate("/login", { replace: true });
      return;
    }
    (async () => {
      try {
        const { data } = await apiClient.post("/auth/session", { session_id: sessionId });
        loginWithToken(data.token, data.user);
        window.history.replaceState(null, "", "/dashboard");
        navigate("/dashboard", { replace: true });
      } catch {
        navigate("/login", { replace: true });
      }
    })();
  }, [navigate, loginWithToken]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center gap-4 wave-bg">
      <Loader2 className="h-7 w-7 animate-spin text-orange" />
      <p className="label-overline">Hauling you aboard</p>
    </div>
  );
}
